import { useState, useEffect } from "react";
import { Clock } from "lucide-react";

interface CompactEventCountdownProps {
  eventDate: string;
}

export const CompactEventCountdown = ({ eventDate }: CompactEventCountdownProps) => {
  const [timeLeft, setTimeLeft] = useState<{
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  } | null>(null);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(eventDate).getTime() - new Date().getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        setTimeLeft(null);
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [eventDate]);

  if (!timeLeft) {
    return (
      <span className="text-sm text-muted-foreground flex items-center gap-1">
        <Clock className="h-3 w-3" />
        Event has started
      </span>
    );
  }

  return (
    <span className="text-sm text-primary font-medium flex items-center gap-1">
      <Clock className="h-3 w-3" />
      {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
    </span>
  );
};
